
<script>
	import listBase from '@_system/components/base/list.vue'
	import Detail from './lib/detail.vue'
	import staffIndex from './staff/index.vue'
	export default {
		extends: listBase,
		name: 'joblevelIndex',
		props: {

		},
		render(h) {
			this.$slots.footer = [
				<div style="position: relative;width: 100%;height:100%;">
					<staff-index list={this} ref="joblevelstaff" row={this.currentrow} />
				</div>
			]
			this.$slots.plug = [
				<vxe-modal v-model={this.detailShow} width="1200" height="600" title={this.detailTitle} destroy-on-close show-footer size="mini">
					<Detail joblevelid={this.joblevelid} />
				</vxe-modal>,
			]
			return listBase.render.call(this, h)
		},
		data() {
			return {
				componenttype:'system',
				moduleName: 'joblevel',
				windowName: '职务级别',
				detailShow: false,
				detailTitle: '详情',
				joblevelid: 0
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			cellClick({row}) {
				
				this.currentrow = row
				this.$nextTick(()=>{
					this.$refs.joblevelstaff.getstaff()
				})
			},
			detail(row) {
				this.joblevelid = row.id
				this.detailTitle = '详情：' + row.name
				this.detailShow = true
			},
			add() {
				import('@_system/components/forms/organization/joblevel/form.vue').then((res) => {
					this.formModule = {
						component: res.default,
						name: 'joblevel',
						id: 0,
						controlltype: 1,
						show: true,
					}
				})

			},
			edit(row) {
				import('@_system/components/forms/organization/joblevel/form.vue').then((res) => {
					this.formModule = {
						component: res.default,
						name: 'joblevel',
						id: row.id,
						controlltype: 2,
						show: true,
					}
				})
			},

		},
		components: {
			Detail,
			staffIndex
		}
	}
</script>
